import { angleContain } from '../../../lib/util/mathTools';
import { Vector2 } from '../../../odie';
import { Particle } from '../Particle';
import { IBehavior } from './IBehavior';

// types
//-----------------------------------------------------------------------------
export type KinematicBehaviorOptions = {
  type: 'kinematic';
  directionalRotation?: boolean;
  rotationOffset?: number;
};

/*
    kinematic motion
*/
export class KinematicBehavior implements IBehavior {
  // fields
  //-------------------------------------------------------------------------
  private _particle: Particle;
  private _options: KinematicBehaviorOptions;

  // init
  //-------------------------------------------------------------------------
  constructor(particle: Particle, options: KinematicBehaviorOptions) {
    this._particle = particle;
    this._options = options;
  }

  // impl
  //-------------------------------------------------------------------------
  public step(dt: number) {
    const particle = this._particle;
    const position = new Vector2(particle.x, particle.y);

    // p1 = p0 + v0 * dt;
    position.add(particle.velocity.clone().multiplyScalar(dt));

    // r1 = r0 + v0 * dt;
    if (this._options.directionalRotation) {
      const offset = this._options.rotationOffset ?? 0;
      const angle = Math.atan(particle.velocity.y / particle.velocity.x);
      particle.rotation = angleContain(offset - angle);
    } else {
      particle.rotation = angleContain(
        particle.rotation + particle.angularVelocity * dt,
      );
    }

    // commit
    particle.x = position.x;
    particle.y = position.y;
  }
}
